import { useState, useRef, useEffect } from 'react';
import { AuthLayout } from '../layout/AuthLayout.jsx';
import { FormField } from '../components/FormField.jsx';
import { TextInput } from '../components/TextInput.jsx';
import { SubmitButton } from '../components/SubmitButton.jsx';
import { FormError, FormSuccess } from '../components/FormError.jsx';
import { api } from '../api/client.js';

export function ForgotPasswordPage({ navigate }) {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const emailRef = useRef(null);

  useEffect(() => { emailRef.current?.focus(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setError(null);
    setSuccess(null);
    setSubmitting(true);
    try {
      const data = await api.passwordResetRequest({ email: email.trim() });
      setSuccess(
        data?.message ||
          'If this email exists, a reset link has been sent. Check your inbox.',
      );
    } catch (e2) {
      setError(e2);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Forgot your password?"
      subtitle="Enter your email and we'll send you a reset link."
    >
      <form onSubmit={handleSubmit} noValidate>
        <FormError error={error} />
        <FormSuccess message={success} />
        <FormField label="Email" htmlFor="forgot-email">
          <TextInput
            id="forgot-email"
            name="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            ref={emailRef}
            required
          />
        </FormField>
        <SubmitButton loading={submitting}>Send reset link</SubmitButton>
      </form>
      <div className="auth-links">
        <a
          href="/login"
          onClick={(ev) => { ev.preventDefault(); navigate('/login'); }}
        >Back to log in</a>
      </div>
    </AuthLayout>
  );
}
